<template>
  <div>

    <!-- First Drag and Drop Component
        where user can click or drag file - will open
        dialog -->
    <DragAndDropFile
        ref="dragAndDrop1"
        @fileChange="openForm"
    />

    <v-dialog
        fullscreen
        eager
        v-model="dialog"
        hide-overlay
        content-class="form-dialog"
    >
      <v-card elevation="0">
        <v-col class="text-right px-4">
          <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
        </v-col>

        <v-card-text>
          <v-form ref="form">
            <v-row class="pa-5" justify="space-between">
              <v-col cols="12"><h3 class="font-weight-bold">{{ $t('buttons:add-specific', { specific: $t('common:documentation')}) }}</h3></v-col>
              <v-col cols="12" md="7">
                <!-- Second Drag and Drop component
                    where user can change file again -->
                <DragAndDropFile
                    ref="dragAndDrop2"
                    @fileChange="setFile($event)"
                    custom-height="75vh"/>
              </v-col>

              <v-col cols="12" md="4">
                <!-- Input Fields -->
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        v-model="documentation.name"
                        outlined
                        :label="$t('common:document-name')"
                        :rules="[ruleRequired($t('utils:rules.required'))]"
                    />

                    <DateField
                        ref="start"
                        @update="(v) => (documentation.startDate = v)"
                        :isClearable="true"
                        :label="$t('common:valid-from')"
                    />

                    <DateField
                        ref="end"
                        @update="(v) => (documentation.endDate = v)"
                        :isClearable="true"
                        :label="$t('common:valid-until')"
                    />
                  </v-col>
                </v-row>

                <BaseButton
                    color="primary"
                    :btnText="$t('buttons:add-specific', { specific: $t('common:documentation')})"
                    @clickedButton="uploadDocumentation()"
                />

                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:cancel')"
                    color="grey"
                    :dialog-title="$t('dialog:dirty-save-btn-title')"
                    :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="closeDialog"
                    :dataToWatch="documentation"
                    hideOverlay
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import {ruleRequired} from "@/modules/core/services/rules";
import Utils from "@/modules/core/services/utils";

import Documentation from "@/modules/book/data/documentation";

import DateField from "@/modules/core/components/DateField";
import DragAndDropFile from "@/modules/core/components/DragAndDropFile"
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";

export default {
  name: 'ProcessDocuUploadForm',
  components: {
    DateField,
    DragAndDropFile,
    DirtyConfirmButtonDialog,
    BaseButton
  },
  data() {
    return {
      dialog: false,
      file: null,
      documentation: new Documentation(),
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  methods: {
    // File-Setter method for dragAndDrop 2
    setFile(item) {
      this.file = item;

      if (item) {
        let docuToParse = {
          fileType: item.type,
          src: URL.createObjectURL(item)
        }
        this.$refs.dragAndDrop2.setPreviewSrc(docuToParse)
      } else {
        this.$refs.dragAndDrop2.setPreviewSrc(null)
      }

      this.$refs.dragAndDrop2.file = item;
      this.$refs.dragAndDrop2.isUploading = false;
    },

    // File-Setter for dragAndDrop2 and opener for dialog
    openForm(file) {
      this.dialog = true;
      this.file = file;

      if (file) {
        let docuToParse = {
          fileType: file.type,
          src: URL.createObjectURL(file)
        }
        this.$refs.dragAndDrop2.setPreviewSrc(docuToParse)
      } else {
        this.$refs.dragAndDrop2.setPreviewSrc(null)
      }

      this.$refs.dragAndDrop2.file = file;
      this.$refs.dragAndDrop1.isUploading = false;
    },

    // uploading documentation
    uploadDocumentation() {
      if (!this.$refs.form.validate()) {
        return;
      }

      let reader = new FileReader();
      const startDate = this.documentation.startDate;
      const endDate = this.documentation.endDate;
      const name = this.documentation.name;
      const file = this.file;

      reader.addEventListener("load", () => {
        let document = new Documentation();

        if (startDate == null) {
          document.startDate = '';
        } else {
          document.startDate = startDate;
        }

        if (endDate == null) {
          document.endDate = endDate;
        } else {
          document.endDate = endDate;
        }
        document.src = reader.result;
        document.name = name;
        document.fileType = file.type;
        document.file = file;
        document.fileName = file.name;
        document.toSave = true;

        // define a unique local id, so the delete handling will be easier
        document.localId = Utils.generateUUIDv4();
        this.$emit('documentationCreated', document);
        Utils.showSuccessSnackbar(this.$t('snackbar:upload-success', {name: this.$t('common:documentation')}));
        this.closeDialog();
      }, false);

      if (this.file) {
        reader.readAsDataURL(this.file);
      }
    },
    ruleRequired,

    // dialog cleaner and closer
    closeDialog() {
      this.dialog = false;
      this.file = null;
      this.$refs.dragAndDrop1.clear();
      this.$refs.dragAndDrop2.clear();
      this.$refs.form.reset();
      this.$refs.start.localDate = ''
      this.$refs.end.localDate = ''
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    }
  }
}
</script>